<template>
    <!-- <vs-chip class="ag-grid-cell-chip" :color="options[params.value].color">
      <span>{{ options[params.value].label }}</span>
    </vs-chip> -->
    <span>{{ options[params.value].label }}</span>
</template>

<script>
import moduleDevice from '@/store/device/moduleDevice.js'
    export default {
        name: 'CellRendererType',
        data() {
          return {
            options: moduleDevice.deviceTypeList,
          }
        },
    }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
